import { Link } from "react-router-dom";
import { Name } from "@app/types/enums";
import { AnnotationComponentProps } from "@pages/Article/components/StoryElements/Annotation/utils/types";
import { getFieldValue } from "@util/helpers";
import { isEmpty } from "lodash-es";

export default function AnnotationComponentExternalLink({
  children,
  element,
}: AnnotationComponentProps): React.ReactElement {
  const uri = getFieldValue(element?.fields || [], Name.Uri);
  const isNewWindow = getFieldValue(element?.fields || [], Name.NewWindow);
  const isNoFollow = getFieldValue(element?.fields || [], Name.NoFollow);

  return (
    <>
      {typeof uri === "string" && !isEmpty(uri) ? (
        <Link
          to={uri}
          target={isNewWindow ? "_blank" : undefined}
          rel={isNoFollow ? "nofollow" : undefined}
          reloadDocument
        >
          {children}
        </Link>
      ) : null}
    </>
  );
}
